export default "__VITE_ASSET__BQWC583q__"